<template>
  <el-dialog
    :visible="show"
    title="修改日志"
    @close="handleClose"
    @open="handleOpen"
  >
    <el-table border :data="list" size="mini" height="700">
      <el-table-column label="更新类型" prop="type_formal"></el-table-column>
      <el-table-column label="更新人" prop="update_admin"></el-table-column>
      <el-table-column label="更新时间" prop="updated_at"></el-table-column>
      <el-table-column label="更新文件">
        <template #default="{ row }">
          <el-button
            v-if="row.file_url"
            type="text"
            icon="el-icon-download"
            @click="handleDownload(row)"
            >下载文件</el-button
          >
          <span v-else>/</span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

import {
  getShippingConnectLog,
  getShippingCooperateLog,
} from "@/controller/expressOptimization3041.js";

export default {
  name: "ChangeLogDialog",
  model: {
    prop: "show",
    event: "toggle",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    originId: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      require: true,
      validator(value) {
        return ["connect", "cooperate"].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    handleClose() {
      this.$emit("toggle", false);
    },
    handleOpen() {
      this.getShippingConnectLog();
    },
    handleDownload(row) {
      window.open(row.file_url);
    },
    async getShippingConnectLog() {
      try {
        const apiFunc =
          this.type === "cooperate"
            ? getShippingCooperateLog
            : getShippingConnectLog;
        const data = await apiFunc({
          origin_id: this.originId,
        });
        this.list = data;
      } catch (err) {
        console.log("error [getShippingConnectLog]", err);
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/wavepicking/ShippingRule/components/ChangeLogDialog.vue